import React from 'react'

function Error(){
	return(
	<section id="services">
      <div class="container">
        <div class="section-header"><br/><br/><br/><br/>404 No Pages Found</div></div></section>
)
	}
	
export default Error